import { Container } from "react-bootstrap";

import './Error.css';

function Error(prop: any) {

    var code = prop.code;
    var content = '';

    switch(String(code)){
        case '404':
            content = 'Page not found.';
            break;
    
        default:
            content = 'Unknown error occurred.';
            break;
    }

    return (
        <>
            <Container className='text-center'>
                <div className='display-1'>{code}</div>
                <div className='error-content-text lead'>{content}</div>
            </Container>
        </>
    );
}

export default Error;